import React from "react";
import { Link } from "react-router-dom";
import "../css/policies.scss";

export const LAST_UPDATED = "October 16, 2026";

export const policyLinks = [
  ["/privacy", "Privacy policy"],
  ["/data-choices", "Privacy choices"],
  ["/cookies", "Cookie policy"],
  ["/terms", "Terms of service"],
  ["/orders", "Order & cancellation policy"],
  ["/payments", "Payment policy"],
  ["/pricing", "Pricing, taxes & duties"],
  ["/shipping", "Shipping & delivery policy"],
  ["/returns", "Returns & refund policy"],
  ["/warranty", "Product warranty policy"],
  ["/product-safety", "Product safety & recalls"],
  ["/promotions", "Promotions policy"],
  ["/acceptable-use", "Acceptable use policy"],
  ["/intellectual-property", "Intellectual property policy"],
  ["/accessibility", "Accessibility statement"],
  ["/complaints", "Complaints & dispute policy"],
  ["/site-notice", "Website notice & disclaimer"],
];

export const EmailLink = ({ subject, children = "mall@tunrisefield.xyz" }) => (
  <a
    href={`mailto:mall@tunrisefield.xyz${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`}
  >
    {children}
  </a>
);

function PolicyLayout({ title, intro, children }) {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="policy-page">
      <header className="policy-page__header">
        <Link className="policy-page__eyebrow" to="/policies" onClick={toTop}>
          tunrisefield policy center
        </Link>
        <h1>{title}</h1>
        <p className="policy-page__updated">Last updated: {LAST_UPDATED}</p>
        {intro && <p className="policy-page__intro">{intro}</p>}
      </header>

      <div className="policy-page__content rte">{children}</div>

      <aside className="policy-page__directory" aria-labelledby="policy-directory-title">
        <h2 id="policy-directory-title">all store policies</h2>
        <nav aria-label="Store policies">
          {policyLinks.map(([path, label]) => (
            <Link key={path} to={path} onClick={toTop}>
              {label}
            </Link>
          ))}
        </nav>
      </aside>
    </main>
  );
}

export default PolicyLayout;
